/** Avatar background color variant from name (lighter backgrounds, darker text). Used in People 2 and comments. */
export function getAvatarColorClass(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash |= 0;
  }
  const v = Math.abs(hash) % 3;
  if (v === 0) {
    return 'bg-blue-100 text-blue-800';
  }
  if (v === 1) {
    return 'bg-slate-200 text-slate-700';
  }
  return 'bg-amber-100 text-amber-800';
}
